import useCrud from '../useCrud'

const useTemplate = () => {
  const { get: getQuery } = useCrud('/admin/v1/templates/published')

  const getPublishedTemplates = () => getQuery(['templates'])

  return { getPublishedTemplates }
}

export default useTemplate
